export const FETCH_DATA_RESTAURANT_SUCCESS = "FETCH_DATA_RESTAURANT_SUCCESS";

export const REQUEST_UPDATE_FROZEN_SLOTS = "REQUEST_UPDATE_FROZEN_SLOTS";
export const REQUEST_UPDATE_FROZEN_SLOTS_SUCCESS = "REQUEST_UPDATE_FROZEN_SLOTS_SUCCESS";

export const REQUEST_CREATE_TOKEN_STRIPE_FINISHED = "REQUEST_CREATE_TOKEN_STRIPE_FINISHED";
export const REQUEST_CREATE_TOKEN_STRIPE = "REQUEST_CREATE_TOKEN_STRIPE";
export const PRE_CREATE_TOKEN_STRIPE = "PRE_CREATE_TOKEN_STRIPE";
export const CREATE_TOKEN_STRIPE = "CREATE_TOKEN_STRIPE";

export const REQUEST_CHECK_SERVICE_OPEN_RESTAURANT_FINISHED = "REQUEST_CHECK_SERVICE_OPEN_RESTAURANT_FINISHED";
export const REQUEST_CHECK_SERVICE_OPEN_RESTAURANT = "REQUEST_CHECK_SERVICE_OPEN_RESTAURANT";
export const CHECK_SERVICE_OPEN_RESTAURANT_SUCCESS = "CHECK_SERVICE_OPEN_RESTAURANT_SUCCESS";
export const PRE_CHECK_SERVICE_OPEN_RESTAURANT = "PRE_CHECK_SERVICE_OPEN_RESTAURANT";